<template>
    <div>
        <TopBarText :title="pageTitle" />
        <div v-if="isMarketingTemplate">
            <img v-if="isStandard" class="image_register" :src="configTni.marketingtemplate_renewal_register_image_url" alt="" />
            <img v-if="!isStandard" class="image_register" :src="configTni.consent_image_url" alt="" />
        </div>
        <div v-else-if="isNewRegister">
            <img v-if="isStandard" class="image_register" :src="configTni.new_register_image_url" alt="" />
            <img v-if="!isStandard" class="image_register" :src="configTni.consent_image_url" alt="" />
        </div>
        <div v-else>
            <img v-if="isStandard" class="image_register" :src="configTni.consent_standard_register_image_url" alt="" />
            <img v-if="!isStandard" class="image_register" :src="configTni.consent_image_url" alt="" />
        </div>

        <div class="consent_wrapper">
            <div class="iframe_wrapper" :class="[isStandard?'isStandard':'']">
                <iframe id="terms_iframe" class="w-full" :src="configTni.consent_text_url" title=""></iframe>
            </div>
            <div class="bottom_wrapper">
                <div class="btn_accept" @click="gotoNextPage()">{{lbl.consent_register.accept}}</div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin'
//component
import TopBarText from "../component/TopBarText.vue";
//service
import ConsentApi from '../service/ConsentApi';
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "ConsentRegister",
    mixins: [LocaleMixin],
    props: {
        nextPage: {
            type: String
        },
        isStandard: {
            type: Boolean,
        },
    },
    components: {
        TopBarText,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            configTni: {},
            pageTitle: "",
            isMarketingTemplate: false,
            isNewRegister: false,
        }
    },
    created: function() {
        this.pageTitle = this.lbl.consent_register.page_title;
        this.getBlobConfig();
        if (this.$route.query.MarketingTemplate) {
            this.isMarketingTemplate = true
        }
        if (this.$route.name == 'newregister') {
            this.isNewRegister = true
        }
    },
    methods: {
        getBlobConfig: function() {
            ConsentApi.apiGetTniConfig().subscribe({
                next: (data) => {
                    this.configTni = data;
                    console.log('configTni', data);
                },
                error: (err) => {
                    this.errorApi(err);
                },
            });
        },
        gotoNextPage: function () {
            if (this.isStandard) {
                this.tracking.event("register_standard_page", "click_submit", "", "");
            } else {
                this.tracking.event("register_ttb_page", "click_submit", "", "");
            }
            if (this.isMarketingTemplate) {
                window.location.replace(this.nextPage + '?MarketingTemplate=true');
            } else {
                window.location.replace(this.nextPage);
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.iframe_wrapper {
    padding: 0 8px;
    bottom: 60px;
    width: 100%;
    padding-bottom: 20px;
    left: 0;

    height: calc(100vh - 288px);
    &.isStandard {
        height: calc(100vh - 296px);
        height: calc(100vh - 284px);
    }
    border-bottom: 6px solid #f5f5f5;

    #terms_iframe {
        width: 100%;
        border: none;
        height: 100%;
    }
}
.image_register {
    @apply pt-4 pr-9 pl-9 pb-4;
}
.bottom_wrapper {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    @apply  py-3 flex items-center justify-end mr-2 bg-white;
}
.btn_accept {
    @apply w-18 h-10 rounded-5 flex items-center justify-center text-white bg-a-blue-5dc0e0 text-14 font-light font-main ;
}
</style>
